import React from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLinariaClassName = (component: React.FC<any>) =>
  // @ts-expect-error property doesn't exist
  component?.__wyw_meta?.className
